const styles = {
	maxWidth: { width: '100%' },
	textCenter: { textAlign: 'center' } as React.CSSProperties,
	inputNumber: { width: '100%', textAlign: 'right' } as React.CSSProperties,
};

export default styles;
